import { view } from '@yola/ws-sdk';
import positionTypes from '../constants/position-types';
import hasFlexRowReverseParent from '../verifiers/has-flex-row-reverse-parent';
import invertAdjacentPosition from './invert-adjacent-position';

const { VERTICAL, HORIZONTAL } = view.elementFlowTypes;

const getOuterAdjacentPosition = (element, x, y) => {
  if (element === null) return null;

  const flowType = view.helpers.getElementFlowType(element);
  const { top, bottom, left, right } = element.getBoundingClientRect();
  const centerX = (left + right) / 2;
  const centerY = (top + bottom) / 2;

  let position = positionTypes.AFTER_END;

  if ((flowType === HORIZONTAL && x < centerX) || (flowType === VERTICAL && y < centerY)) {
    position = positionTypes.BEFORE_BEGIN;
  }

  if (flowType === HORIZONTAL && hasFlexRowReverseParent(element)) {
    position = invertAdjacentPosition(position);
  }

  return position;
};

export default getOuterAdjacentPosition;
